<div id="blocklyDiv" style="height: 800px; width: 100%"></div>
<!--
<xml id="toolbox" style="display: none">
  <category name="WhatsApp">
    <block type="whatsapp_template"></block>
  </category>
  <category name="Textos">
    <block type="text_multiline"></block>
    <block type="text"></block>
    <block type="text_length"></block>
    <block type="text_join"></block>
    <block type="text_append"></block>
    <block type="text_isEmpty"></block>
    <block type="text_replace"></block>
    <block type="text_trim"></block>
    <block type="text_changeCase"></block>
  </category>
  <category name="Condições">
    <block type="controls_if"></block>
    <block type="logic_compare"></block>
    <block type="logic_operation"></block>
    <block type="logic_negate"></block>
    <block type="logic_boolean"></block>
    <block type="logic_null"></block>
    <block type="logic_ternary"></block>
  </category>
  <category name="Variáveis">
    <block type="variables_set"></block>
    <block type="variables_get"></block>
    <block type="variables_get">
      <field name="VAR">quantidade</field>
    </block>
    <block type="variables_get">
      <field name="VAR">nome_contato</field>
    </block>
    <block type="variables_get">
      <field name="VAR">valor_pedido</field>
    </block>
    <block type="variables_get">
      <field name="VAR">forma_pagamento</field>
    </block>
    <block type="variables_get">
      <field name="VAR">telefone_contato</field>
    </block>
    <block type="variables_get">
      <field name="VAR">nome_empresa</field>
    </block>
  </category>
  <category name="Dados Pedido">
    <block type="variables_get">
      <field name="VAR">valor_pedido</field>
    </block>
    <block type="variables_get">
      <field name="VAR">forma_pagamento</field>
    </block>
  </category>
  <category name="Dados Contato">
    <block type="variables_get">
      <field name="VAR">nome_contato</field>
    </block>
    <block type="variables_get">
      <field name="VAR">telefone_contato</field>
    </block>
  </category>
  <category name="Matemática">
    <block type="math_number"></block>
    <block type="math_arithmetic"></block>
  </category>
</xml>
<button (click)="runCode()">Executar</button>
-->
